import { NavLinkProps as NavLinkPropsRRD } from '@cthings.co/router-dom';
//import { Access } from '../app/state/userInterfaces';

export interface NavLinkProps extends NavLinkPropsRRD {
  access: any[];
}

export const defaultAccess = ['permission'];
